var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.297,
    height: 45.297,
    viewBox: "0 0 44.297 45.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17287",
    "data-name": "Groupe 17287",
    transform: "translate(-470 -4159.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17282",
    "data-name": "Groupe 17282",
    transform: "translate(-431 3121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17274",
    "data-name": "Groupe 17274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_17279",
    "data-name": "Groupe 17279"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5352",
    "data-name": "Rectangle 5352",
    width: 40,
    height: 40,
    rx: 5,
    transform: "translate(901 1044)",
    fill: "#08c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-telegram",
    "data-name": "Icon simple-telegram",
    d: "M15.939,4.129,13.532,15.5c-.167.807-.654,1-1.334.627L8.53,13.412,6.756,15.126a.935.935,0,0,1-.734.373c-.48,0-.4-.18-.56-.634L4.195,10.738.56,9.6c-.787-.233-.794-.774.173-1.167L14.912,2.968c.647-.287,1.267.16,1.02,1.154Z",
    transform: "translate(913.012 1054.451)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "chat",
    d: "M12.466,0H5.347A5.344,5.344,0,0,0,.008,5.338V9.489a5.345,5.345,0,0,0,5.042,5.33v2.474a.505.505,0,0,0,.505.5.5.5,0,0,0,.354-.148l.556-.556a7.687,7.687,0,0,1,5.471-2.266h.528A5.344,5.344,0,0,0,17.8,9.489V5.338A5.344,5.344,0,0,0,12.466,0ZM5.05,8.6A1.186,1.186,0,1,1,6.237,7.413,1.187,1.187,0,0,1,5.05,8.6Zm3.856,0a1.186,1.186,0,1,1,1.186-1.186A1.187,1.187,0,0,1,8.906,8.6Zm3.856,0a1.186,1.186,0,1,1,1.186-1.186A1.187,1.187,0,0,1,12.762,8.6Z",
    transform: "translate(926.992 1039.203)",
    fill: "#08c",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "chat_-_Contour",
    "data-name": "chat - Contour",
    d: "M5.347-.5h7.119A5.845,5.845,0,0,1,18.3,5.338V9.489a5.845,5.845,0,0,1-5.839,5.838h-.528A7.19,7.19,0,0,0,6.82,17.446L6.263,18a1,1,0,0,1-.708.294,1.006,1.006,0,0,1-1.005-1v-2.02A5.839,5.839,0,0,1-.492,9.489V5.338A5.845,5.845,0,0,1,5.347-.5Zm7.119,14.827A4.844,4.844,0,0,0,17.3,9.489V5.338A4.844,4.844,0,0,0,12.466.5H5.347A4.844,4.844,0,0,0,.508,5.338V9.489a4.838,4.838,0,0,0,4.57,4.83l.473.026v2.948a.005.005,0,0,0,.005,0l.557-.558a8.183,8.183,0,0,1,5.825-2.412ZM5.05,5.727A1.686,1.686,0,1,1,3.364,7.413,1.688,1.688,0,0,1,5.05,5.727Zm0,2.372a.686.686,0,1,0-.686-.686A.687.687,0,0,0,5.05,8.1ZM8.906,5.727A1.686,1.686,0,1,1,7.22,7.413,1.688,1.688,0,0,1,8.906,5.727Zm0,2.372a.686.686,0,1,0-.686-.686A.687.687,0,0,0,8.906,8.1Zm3.856-2.372a1.686,1.686,0,1,1-1.686,1.686A1.688,1.688,0,0,1,12.762,5.727Zm0,2.372a.686.686,0,1,0-.686-.686A.687.687,0,0,0,12.762,8.1Z",
    transform: "translate(926.992 1039.203)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramChat);
export default __webpack_public_path__ + "static/media/telegramChat.5334c0bca8950385e46ce49a6cef4e68.svg";
export { ForwardRef as ReactComponent };